export const profileClassnames = [
  'imda-theme--purple imda-profile1',
  'imda-theme--maroon imda-profile2',
  'imda-theme--teal imda-profile3',
  'imda-theme--purple imda-profile0'
];